import styles from "./index.module.scss";
export const BuyerTable = ({
  waitingSellerCompleteOrderStr = "15分钟"
}: {
  waitingSellerCompleteOrderStr?: number | string;
}) => {
  return <table className={styles.table} data-sentry-component="BuyerTable" data-sentry-source-file="data.tsx">
      <thead>
        <tr>
          <th>买方异常</th>
          <th>处理措施</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1、订单创建后，买方取消订单。</td>
          <td>
            当日达到3次，系统将限制买方 买入功能；连续2日触发，将进
            一步限制买方账户部分功能。
          </td>
        </tr>
        <tr>
          <td>2、订单创建后，因付款超时而 系统自动取消订单。</td>
          <td>
            当日达到3次，系统将限制买方 买入功能；连续2日触发，将进
            一步限制买方账户部分功能。
          </td>
        </tr>
        <tr>
          <td>3、未按照卖方订单详情页面显示的收款账户进行付款。</td>
          <td>
            卖家有权要求取消订单，数字资产归还给卖方，买方自行承担转错款的风险。
          </td>
        </tr>
        <tr>
          <td>4、未使用与平台账户实名一致的支付账户付款。</td>
          <td>
            1）卖方有权直接拒绝成交，数字资产归还给卖方。使用企业账户付款（不论法人与认证本人实名是否一致），依然属于非实名支付。
            <br />
            2）若因此行为被投诉，首次违规冻结买卖数字货币权限自订单完成时开始冻结24H。
            <br />
            3）2次及以上违规冻结买卖数字货币权限7天（视情节严重，加重处罚直至永久冻结买卖数字货币权限）。
          </td>
        </tr>
        <tr>
          <td>
            5、在订单规定的付款时间内付款，订单被取消。
            <br />
            （1）买方已完成所有付款，订单被系统超时取消；
            <br />
            （2）买方完成部分付款，但订单被系统超时取消。
          </td>
          <td>
            订单被系统超时取消的，买方有权选择申请客服介入，将订单转为争议订单。
            买方需要在15分钟内提交申请客服介入，超时提交可能会给后续处理带来不必要的麻烦。
            <br />
            1）如卖方选择成交，可由平台协助操作确认交易，放行数字货币即可。
            <br />
            2）如卖方选择取消订单，则卖方需在收到平台或者买方用户反馈后60分钟内完成退款，数字资产归还给卖方；若卖方不积极配合退款，将按获取非正当得利相关规则执行。
          </td>
        </tr>
        <tr>
          <td>6、付款金额与订单金额不符。</td>
          <td>
            1）付款金额大于订单金额的，订单成交，卖家应于收到款项后60分钟内退还多余部分款项。
            <br />
            2）付款金额小于订单金额的，卖方有权选择继续成交或取消订单。
            <br />
            —如卖方选择继续成交，则按实际订单金额进行成交，并完成此订单。
            —如卖方选择取消订单，数字资产归还给卖方，但买方有权提出申诉要求卖方退款，卖方需在收到付款后60分钟内完成退款，若卖方不积极配合退款，将按获取非正当得利相关规则执行。
          </td>
        </tr>
        <tr>
          <td>7、买方点击“我已付款”后，卖方未收到付款。</td>
          <td>
            1）卖方有权选择继续成交或取消订单。
            <br />
            —如卖方选择成交，卖方将在
            <span style={{
            color: "red"
          }}>
              {waitingSellerCompleteOrderStr}
            </span>
            内完成放行。
            <br />
            —如卖方选择取消订单，数字资产归还给卖方，若卖方后续收到付款，需在收到付款后60分钟内完成退款。
            <br />
            2）卖方选择取消订单，申诉争议订单后15分钟内无法联系上买方，经核实卖方未收到款，在卖方保证资产范围内申诉专员会优先取消订单。
          </td>
        </tr>
        <tr>
          <td>8、付款到账后，卖方收款账户无法核实到账实名信息。</td>
          <td>
            1）经核实买方付款账户与平台实名账户一致，且在订单规定时间内完成了付款，此订单正常成交。
            <br />
            2）经核实买方付款账户与平台实名账户不一致，按上述第4条措施处理。
          </td>
        </tr>
        <tr>
          <td>9、使用未经卖方同意的非实时到账方式支付订单的。</td>
          <td>
            卖方有权选择继续成交或退款后要求取消订单：
            —如卖方选择成交，卖方需要在收到付款的20分钟内完成放行。
            —如卖方选择取消订单，则卖方需在收到付款后60分钟内完成退款，数字资产归还给卖方；
          </td>
        </tr>
        <tr>
          <td>10、因买方付款导致卖方收款账户异常。</td>
          <td>
            1）买方无法提供账户正常证明，卖方应在收款账户转至正常后，24小时内完成退款，平台取消订单。
            <br />
            2）买方能提供账户正常证明，在核实买方账户无异常后，订单成交，数字资产应交付买方。
            <br />
            3）冻结买卖币权限，直至个案结束。
          </td>
        </tr>
        <tr>
          <td>11、付款时备注：类似“数字货币、BTC、XX币”等敏感字样的。</td>
          <td>
            卖方有权选择继续成交或退款不成交。
            <br />
            1）如卖方选择成交，卖方应在收到付款的20分钟内完成放行。
            <br />
            2）如卖方选择订单取消，数字资产归还给卖方，卖方在收到付款后60分钟内完成退款；如卖方收款账户因此被冻结，按上述第10条措施处理
            <br />
            3）若因此行为被投诉，首次违规冻结买卖币权限至登录后，继续冻结24H
            <br />。
            4）2次及以上违规冻结买卖币权限7天（视情节严重，加重处罚直至永久冻结买卖币权限）。
          </td>
        </tr>
        <tr>
          <td>12、客服介入申诉15分钟内仍无法联系上买方的。</td>
          <td>
            1）前2次违规冻结买卖币权限至登录，在线警告并在解决问题后解冻
            <br />
            2）3次及以上违规冻结1个月买卖币权限（视情节严重，加重处罚直至永久冻结买卖币权限）。
          </td>
        </tr>
        <tr>
          <td>13、预留的联系电话无效的。</td>
          <td>同上</td>
        </tr>
        <tr>
          <td>14、被核实为恶意卡单的。</td>
          <td>同上</td>
        </tr>
        <tr>
          <td>15、被核实为转账测卡行为的。</td>
          <td>
            1）首次违规冻结买卖币权限至登录后，继续冻结24H。
            <br />
            2）2次及以上违规冻结买卖币权限7天（视情节严重，加重处罚直至永久冻结买卖币权限）。
          </td>
        </tr>
        <tr>
          <td>16、被风控系统初步判断为风险用户的。</td>
          <td>
            疑似：冻结买卖币和三方充提上下分权限，直至个案结束。
            <br />
            落实：视情节严重，从重处罚直至永久冻结买卖币和三方充提上下分权限。
          </td>
        </tr>
        <tr>
          <td>17、被投诉出现恶意报警行为的。</td>
          <td>同上</td>
        </tr>
        <tr>
          <td>18、被投诉使用危险资金交易的。</td>
          <td>同上</td>
        </tr>
        <tr>
          <td>19、被投诉使用诈骗资金交易的。</td>
          <td>同上</td>
        </tr>
        <tr>
          <td>20、被投诉诱骗交易对手脱离平台交易的。</td>
          <td>同上</td>
        </tr>
        <tr className={styles.bold}>
          <td>21、提供伪造的转账记录、放行记录、聊天记录等虚假信息。</td>
          <td>永久冻结账户。</td>
        </tr>
      </tbody>
    </table>;
};
export const SellerTable = () => {
  return <table className={styles.table} data-sentry-component="SellerTable" data-sentry-source-file="data.tsx">
      <thead>
        <tr>
          <th>卖方异常</th>
          <th>处理措施</th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td>1、卖方所提供收款账户出现异常。</td>
          <td>
            买方有权选择取消订单。 —如买方选择取消订单的，数字资产归还给卖方
          </td>
        </tr>
        <tr>
          <td>
            2、因卖方未及时提供有效的收款方式，买方无法完成付款，导致订单取消。
          </td>
          <td>
            因卖方不提供收款方式，此订单无法成交，平台在处理申诉时，会直接取消订单，并对卖方用户做处罚，平台取消订单不计买方当天取消次数；
            卖方因此被投诉达到2次，系统将限制卖方账户部分功能。
          </td>
        </tr>
        <tr>
          <td>
            3、卖方未绑定与本人实名一致的有效收款信息或向买方提供与平台实名不一致的收款方式，如：通过支付宝或者微信收款时，账号以及二维码收款人姓名与订单详情页展示的收款人姓名不匹配。
          </td>
          <td>
            1）买方有权取消订单并向平台投诉。
            2）卖方若因此行为被投诉，首次违规冻结法币权限至进线后，继续冻结24H。
            3）2次及以上违规冻结买卖币权限7天（视情节严重，加重处罚直至永久冻结买卖币权限）
          </td>
        </tr>
        <tr>
          <td>4、买方付款账户信息与平台实名信息不一致，未拒绝成交的。</td>
          <td>由此引发的风险，由卖方自行承担。</td>
        </tr>
        <tr>
          <td>
            5、买方全额付款后标记“我已付款”，卖方收到买方全额付款后，未在15分钟内完成放行。
          </td>
          <td>系统将默认交易成功自动放行转币。</td>
        </tr>
        <tr>
          <td>6、客服介入申诉15分钟内仍无法联系上卖方的。</td>
          <td>
            1）前2次违规冻结买卖币权限至登录，在线警告并在解决问题后解冻
            2）3次及以上违规冻结1个月买卖币币权限（视情节严重，加重处罚直至永久冻结买卖币权限）。
          </td>
        </tr>
        <tr>
          <td>7、预留的联系电话无效的。</td>
          <td>同上</td>
        </tr>
        <tr>
          <td>
            8、在交易过程中，收到超过订单金额的款项，不积极配合退还，或获取非正当得利的。
          </td>
          <td>
            疑似：冻结买卖币和三方充提上下分权限，直至个案结束。
            落实：视情节严重，从重处罚直至永久冻结买卖币和三方充提上下分权限。
          </td>
        </tr>
        <tr>
          <td>9、被风控系统初步判断为风险用户的。</td>
          <td>同上</td>
        </tr>
        <tr>
          <td>10、被投诉出现恶意报警行为的。</td>
          <td>同上</td>
        </tr>
        <tr>
          <td>11、被投诉使用危险资金交易的。</td>
          <td>同上</td>
        </tr>
        <tr>
          <td>12、被投诉使用诈骗资金交易的。</td>
          <td>同上</td>
        </tr>
        <tr>
          <td>13、被投诉诱骗交易对手脱离平台交易的。</td>
          <td>同上</td>
        </tr>
        <tr className={styles.bold}>
          <td>14、提供伪造的转账记录、放行记录、聊天记录等虚假信息。</td>
          <td>永久冻结账户。</td>
        </tr>
      </tbody>
    </table>;
};
export const RiskTable = () => {
  return <table className={styles.table} data-sentry-component="RiskTable" data-sentry-source-file="data.tsx">
      <thead>
        <tr>
          <th>卖方异常</th>
          <th>处理措施</th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td>
            1、当用户被风控系统检测到异常，用户明确拒绝或不积极配合完成平台风控要求的进一步反洗钱核查工作
          </td>
          <td>
            本平台将有权选择直接认定为此账户异常，并对此采取包括但不限于上调用户风险等级、直接冻结此类用户的账户及关联账户直至用户配合提供的风控举证材料已通过平台的风控审核。
          </td>
        </tr>
        <tr>
          <td>
            2、账户非本人使用或为他人非法代买币：当用户被平台风控核实出账户存在出售、出借、租赁自身账户为他人使用的情况，或存在为他人非法代充提上下分的行为。
          </td>
          <td>
            本平台将有权选择包括但不限于暂时或永久限交易、限制买卖币或直接冻结此类用户的账户及关联账户等某项或多项措施
          </td>
        </tr>
        <tr>
          <td>
            3、接收或引入来源不合法的资金：当用户明知或据合理常识判断可推知在其他平台/银行卡/微信群收到的资金为黑钱时，但仍无视风险并直接将该黑钱流入到本平台其它用户的账户。
          </td>
          <td>本平台将直接永久限制此类用户的账户及关联账户全部功能。</td>
        </tr>
        <tr>
          <td>
            4、被认定洗钱的用户：当用户被风控系统检测或风控工作人员核实，用户直接参与或协助洗黑钱等犯罪行为
          </td>
          <td>本平台将直接永久限制此类用户的账户及关联账户全部功能。</td>
        </tr>
        <tr>
          <td>5、被司法冻结：当用户账户被司法机构要求冻结时。</td>
          <td>
            本平台将严格按照司法机构出示的司法函件对用户账户进行冻结。当冻结期满，司法机构需出示续冻函方可继续冻结。冻结期间，用户向本平台申请解冻无效，请联系冻结机构协调。
          </td>
        </tr>
        <tr>
          <td>
            6、被司法调证：用户被司法机构要求调取本平台账户资料，包括但不限于：司法调证、咨询等形式
          </td>
          <td>本平台将视情况限制此类用户的账户及关联账户的部分功能。</td>
        </tr>
      </tbody>
    </table>;
};